export class ExpirationModalConfig {

  content: string;
  logOutEarly: string;
  stayLoggedIn: string;
  returnToLogin: string;
  title: string;
  closed: (value: any) => void;

  constructor(
    content?: string,
    logOutEarly?: string,
    stayLoggedIn?: string,
    returnToLogin?: string,
    title?: string,
    closed?: (value: any) => void
  ) {
    this.content = content;
    this.logOutEarly = logOutEarly;
    this.stayLoggedIn = stayLoggedIn;
    this.returnToLogin = returnToLogin;
    this.title = title;
    this.closed = closed;
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/shared/expiration-modal/expiration-modal-config.ts